import { StatementDataState } from "@bToC/Store/Data/Statements/StatementState";
import DataState, { DataViewState, getById, getDataView } from "@insite/client-framework/Store/Data/DataState";

export default interface CustomDataState extends DataState {
    readonly statements: StatementDataState;
}

export const getCustomById = getById;

export const getCustomDataView = getDataView;
